import script from "./GmxSubTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxSubTable.vue?vue&type=script&setup=true&lang=js"

import "./GmxSubTable.vue?vue&type=style&index=0&id=45a0cc0e&scoped=true&lang=scss"
import "./GmxSubTable.vue?vue&type=style&index=1&id=45a0cc0e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a0cc0e"]])

export default __exports__